import { Phone, MessageCircle, Calendar } from "lucide-react";
import { Link } from "react-router-dom";
import { CLINIC } from "@/data/clinic";

export default function MobileBottomBar() {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.06)] grid grid-cols-3"
      data-testid="mobile-bottom-bar"
    >
      <a
        href={`tel:+91${CLINIC.phone}`}
        data-testid="mobile-call-btn"
        className="flex flex-col items-center justify-center py-2.5 gap-0.5 text-slate-900 active:bg-slate-100"
      >
        <Phone className="w-4 h-4 text-green-700" />
        <span className="text-[11px] font-medium">Call Now</span>
      </a>
      <a
        href={`https://wa.me/${CLINIC.whatsapp}?text=Hello%20Dr.%20Ashutosh%20Mishra,%20I%20would%20like%20to%20book%20an%20appointment.`}
        target="_blank"
        rel="noreferrer"
        data-testid="mobile-whatsapp-btn"
        className="flex flex-col items-center justify-center py-2.5 gap-0.5 text-slate-900 active:bg-slate-100 border-x border-slate-200"
      >
        <MessageCircle className="w-4 h-4 text-[#25D366]" />
        <span className="text-[11px] font-medium">WhatsApp</span>
      </a>
      <Link
        to="/contact"
        data-testid="mobile-book-btn"
        className="flex flex-col items-center justify-center py-2.5 gap-0.5 bg-green-700 text-white active:bg-green-800"
      >
        <Calendar className="w-4 h-4" />
        <span className="text-[11px] font-medium">Book Now</span>
      </Link>
    </div>
  );
}
